var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2500_76868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9086 2.80608C11.0439 2.31441 10.42 1.52746 10.2253 0.610656C10.1833 0.412628 10.1599 0.208623 10.1599 0H7.40011L7.39544 9.64581C7.34934 10.7261 6.32982 11.593 5.08012 11.593C4.69169 11.593 4.326 11.5085 4.00392 11.3604C3.26537 11.0217 2.75982 10.3467 2.75982 9.57003C2.75982 8.45438 3.80082 7.54655 5.07981 7.54655C5.31872 7.54655 5.54767 7.58105 5.76416 7.63999V5.18297C5.53988 5.15608 5.31218 5.13978 5.07981 5.13978C2.27887 5.13978 0 7.12686 0 9.57003C0 11.0687 0.858471 12.3951 2.16892 13.197C2.99375 13.7025 3.99769 14 5.08012 14C7.88137 14 10.1599 12.0127 10.1599 9.57003V4.67853C11.2424 5.35601 12.5687 5.75533 14 5.75533V3.34829C13.2291 3.34829 12.5111 3.14863 11.9086 2.80608Z",
    fill: "#F6AF3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2500_76868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.a6df0a8b157365698a1ec8cfa97a475a.svg";
export { ForwardRef as ReactComponent };